import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-visibility-element-edit',
  templateUrl: './visibility-element-edit.component.html',
  styleUrls: ['./visibility-element-edit.component.scss']
})
export class VisibilityElementEditComponent implements OnInit {

  element_type;
  id;
  ml_class_name: null
  posm_audit_type;
  posm_audit_type_ae;
  posm_audit_type_be;
  posm_audit_type_hi;
  posm_audit_type_ka;
  posm_audit_type_ma;
  posm_audit_type_ta;
  posm_audit_type_te;
  posm_type_indicate;
  status: 1
  updated_date: null
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    public toast: ToastClientService,
    public route: ActivatedRoute
    ) { }

  ngOnInit() {
    this.getdata(this.route.snapshot.paramMap.get('id'))
  }


  getdata(id){

    this.apiService.getHeaders(this.apiConfig.getVisibilityList+"&id="+id)
            .subscribe((res: any) => {
              this.id = res.body.data.posm_elements.id;
              this.ml_class_name = res.data.posm_elements.ml_class_name;
              this.posm_audit_type = res.data.posm_elements.posm_audit_type;
              this.element_type = res.data.posm_elements.element_type;
              this.posm_audit_type_ae = res.data.posm_elements.posm_audit_type_ae;
              this.posm_audit_type_be = res.data.posm_elements.posm_audit_type_be;
              this.posm_audit_type_hi = res.data.posm_elements.posm_audit_type_hi;
              this.posm_audit_type_ka = res.data.posm_elements.posm_audit_type_ka;
              this.posm_audit_type_ma = res.data.posm_elements.posm_audit_type_ma;
              this.posm_audit_type_ta = res.data.posm_elements.posm_audit_type_ta;
              this.posm_audit_type_te = res.data.posm_elements.posm_audit_type_te;
              this.posm_type_indicate = res.data.posm_elements.posm_type_indicate;
              this.status = res.data.posm_elements.status;
              this.updated_date = res.data.posm_elements.updated_date;

               console.log(res)
            }, err => {
                console.log(err);
            })
  }

}
